<div class="orders-popup">
  <div class="popup-header">
    <h2>{{isVerificationMode ? 'Order Verification' : 'Orders'}}</h2>
    <button class="close-button" (click)="onClose()">
      <span class="close-icon">×</span>
    </button>
  </div>
  
  <div class="popup-content">
    <!-- Initial Input Mode -->
    <div *ngIf="!isVerificationMode" class="text-wrapper">
      <textarea
        [(ngModel)]="ordersText"
        class="orders-textarea"
        placeholder="Enter orders (one per line)"
      ></textarea>
      
      <div class="button-container">
        <button class="confirm-button" (click)="onConfirm()">Confirm Orders</button>
        <button (click)="onCancel()">Cancel</button>
      </div>
    </div>

    <!-- Verification Mode -->
    <div *ngIf="isVerificationMode && (currentCategory || isPrerequisiteMode)">
      <div class="verification-section">
        <h3>{{ getCurrentOrderName() }}</h3>
        <div class="orders-list">
          <div *ngFor="let order of getCurrentOrdersList()" 
               class="order-item" 
               [class.selected]="isOrderSelected(order)"
               (click)="onOrderClick(order)">
            {{order.orderName}}
          </div>
        </div>
      </div>
      <div class="button-container">
        <button *ngIf="currentCategoryIndex > 0 && !isPrerequisiteMode" (click)="onBack()">Back</button>
        <button 
          *ngIf="!isPrerequisiteMode"
          class="confirm-button" 
          [disabled]="!canProceed()"
          (click)="onConfirm()">
          {{(currentCategoryIndex === categorizedOrdersData.length - 1) ? 'Confirm' : 'Next'}}
        </button>
        <button (click)="onCancel()">Cancel</button>
      </div>
    </div>
  </div>

  <!-- Qualifier Popup -->
  <div *ngIf="showQualifierPopup && selectedOrder" class="qualifier-popup">
    <div class="qualifier-content">
      <div class="qualifier-header">
        <h3>Order Qualifier - {{selectedOrder.orderName}}</h3>
      </div>

      <div class="white-background">
        <div class="qualifier-body">
            <!-- Frequency Section -->
            <div *ngIf="getFrequencyDisplayType() !== 'none'" class="qualifier-section">
              <h4>Frequency</h4>
              
              <!-- Use Case 1: Show input field when frequencyVal contains only [2] -->
              <div *ngIf="getFrequencyDisplayType() === 'input'" class="frequency-input">
                <span>Every</span>
                <input type="number" [(ngModel)]="qualifierData.frequency" placeholder="Enter hours">
                <span>hours</span>
              </div>
              
              <!-- Use Case 2: Show radio buttons for other frequency options -->
              <div *ngIf="getFrequencyDisplayType() === 'radio'" class="radio-group">
                <label *ngFor="let frequency of getFrequencyOptions()">
                  <input type="radio" 
                         [(ngModel)]="qualifierData.selectedFrequencyOption" 
                         [value]="frequency.id" 
                         name="frequency">
                  {{frequency.type}}
                </label>
              </div>
            </div>
    
            <!-- Route/Urgency Section -->
            <div *ngIf="getRouteUrgencyDisplayType() !== 'none'" class="qualifier-section">
              
              <!-- Route Options (when routeUrgencyId === '1') -->
              <div *ngIf="getRouteUrgencyDisplayType() === 'route'">
                <h4>Route</h4>
                <div class="radio-group">
                  <label *ngFor="let route of getRouteOptions()">
                    <input type="radio" 
                           [(ngModel)]="qualifierData.selectedRouteOption" 
                           [value]="route.id" 
                           name="route">
                    {{route.type}} ({{route.abbr}})
                  </label>
                </div>
              </div>
              
              <!-- Urgency Options (when routeUrgencyId === '2') -->
              <div *ngIf="getRouteUrgencyDisplayType() === 'urgency'">
                <h4>Urgency</h4>
                <div class="radio-group">
                  <label *ngFor="let urgency of getUrgencyOptions()">
                    <input type="radio" 
                           [(ngModel)]="qualifierData.selectedUrgencyOption" 
                           [value]="urgency.id" 
                           name="urgency">
                    {{urgency.type}}
                  </label>
                </div>
              </div>
            </div>
          </div>
    
          <div class="qualifier-footer">
            <button (click)="onQualifierConfirm()">OK</button>
            <button (click)="closeQualifierPopup()">Cancel</button>
          </div>
      </div>
    </div>
  </div>

  <!-- Error Popup -->
  <div *ngIf="showErrorPopup" class="qualifier-popup">
    <div class="qualifier-content">
      <div class="qualifier-header">
        <h3>Error</h3>
      </div>

      <div class="white-background">
        <div class="qualifier-body">
          <p>{{errorMessage}}</p>
        </div>

        <div class="qualifier-footer">
          <button (click)="closeErrorPopup()">OK</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Consultation Popup -->
  <div *ngIf="showConsultationPopup" class="consultation-popup">
    <div class="consultation-content">
      <div class="consultation-header">
        <h3>Reason for Consultation - {{ pendingConsultationOrder?.orderName || 'Order' }}</h3>
      </div>

      <div class="white-background">
        <div class="consultation-body">
          <p class="consultation-description">Please enter your reason for consultation in 10 words or less.</p>
          
          <div class="consultation-input-section">
            <textarea 
              [(ngModel)]="consultationReason" 
              class="consultation-textarea"
              placeholder="Enter your reason for consultation..."
              maxlength="200">
            </textarea>
          </div>
        </div>

        <div class="consultation-footer">
          <button (click)="onConsultationConfirm()">OK</button>
          <button (click)="closeConsultationPopup()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div> 




